// 富文本编辑器需要的一些工具函数


/**
 * 图片自定义上传的处理
 * @param {*} files 所要上传的文件合集
 * @param {*} finishedCb 所有文件上传完毕的回调 参数是finishedImageArr 
 * @returns [successCb, failCb] 返回 两个方法用于 OSS上传中成功与失败
 */
export function imgUploadHelper(files = [], finishedCb = () => {}) {
    let total = files.length; // 要上传图片的总数量
    /**
     * 图片上传完毕后形成的数组
     * 对象数组：
     * 成功 -> {
     *     success: true,
     *     data: 图片地址
     * }
     * 失败 -> {
     *     success: false,
     *     data: 文件名称
     * }
     * 
     *  */ 
    let finishedImageArr = [];


    const checkedFinished = () => {
        if (total < 1) {
            finishedCb(finishedImageArr)
        }
    }


    /**
     * 
     * 上传成功回调
     *
     * @param {*} fileIndex 图片下标
     * @returns 
     */
    const successCb = (fileIndex) => (res) => {
        total--;
        finishedImageArr[fileIndex] = {
            success: true, data: res.url
        }
        checkedFinished()
    }

    /**
     * 
     * 上传失败回调
     *
     * @param {*} fileIndex 图片下标
     * @returns 
     */
    const failCb = (fileIndex) => (res) => {
        total--;
        finishedImageArr[fileIndex] = {
            success: false, data: files[fileIndex].name
        }
        checkedFinished()
    }

    return [successCb, failCb];

}
